// extracted by mini-css-extract-plugin
export var narrowContent = "_redotech-redo-customer-portal-app-lib-portal-four-submission-components-modalless-page-layout-narrowContent";
export var root = "_redotech-redo-customer-portal-app-lib-portal-four-submission-components-modalless-page-layout-root";